/*
 * vrtPSTMO.ts
 */
import type { RouteRecordRaw } from 'vue-router';
//
const vrtPSTMO: RouteRecordRaw = {
  path: '/powersteer/tmo',
  name: 'vrtPSTMO',
  component: () => import('src/layouts/vcleSystem.vue'),
  children: [
    // COURSE (TYPE)
    {
      path: 'course/coursetype/list',
      name: 'vrtPSTMOCourseTypeList',
      component: () => import('./vpgPSTMOCourseTypeList.vue'),
    },
    {
      path: 'course/coursetype/operate',
      name: 'vrtPSTMOCourseTypeOperate',
      component: () => import('./vpgPSTMOCourseTypeOperate.vue'),
    },
    {
      path: 'course/lesson/list',
      name: 'vrtPSTMOLessonList',
      component: () => import('./vpgPSTMOLessonList.vue'),
    },
    {
      path: 'course/lesson/operate',
      name: 'vrtPSTMOLessonOperate',
      component: () => import('./vpgPSTMOLessonOperate.vue'),
    },
    {
      path: 'course/coursetype/lesson/list',
      name: 'vrtPSTMOCourseTypeLessonList',
      component: () => import('./vpgPSTMOCourseTypeLessonList.vue'),
    },
    {
      path: 'course/coursetype/lesson/operate',
      name: 'vrtPSTMOCourseTypeLessonOperate',
      component: () => import('./vpgPSTMOCourseTypeLessonOperate.vue'),
    },
    {
      path: 'course/coursetype/platform/list',
      name: 'vrtPSTMOCourseTypePlatformList',
      component: () => import('./vpgPSTMOCourseTypePlatformList.vue'),
    },
    {
      path: 'course/coursetype/platform/operate',
      name: 'vrtPSTMOCourseTypePlatformOperate',
      component: () => import('./vpgPSTMOCourseTypePlatformOperate.vue'),
    },
    // FRAME
    {
      path: 'frame/trainee/list',
      name: 'vrtPSTMOTraineeList',
      component: () => import('./vpgPSTMOTraineeList.vue'),
    },
    {
      path: 'frame/trainee/operate',
      name: 'vrtPSTMOTraineeOperate',
      component: () => import('./vpgPSTMOTraineeOperate.vue'),
    },
    {
      path: 'frame/trainee/frame/list',
      name: 'vrtPSTMOTraineeFrameList',
      component: () => import('./vpgPSTMOTraineeFrameList.vue'),
    },
    {
      path: 'frame/frame/list',
      name: 'vrtPSTMOFrameList',
      component: () => import('./vpgPSTMOFrameList.vue'),
    },
    {
      path: 'frame/frame/operate',
      name: 'vrtPSTMOFrameOperate',
      component: () => import('./vpgPSTMOFrameOperate.vue'),
    },
    {
      path: 'frame/frametrainee/list',
      name: 'vrtPSTMOFrameTraineeList',
      component: () => import('./vpgPSTMOFrameTraineeList.vue'),
    },
    {
      path: 'frame/frametrainee/operate',
      name: 'vrtPSTMOFrameTraineeOperate',
      component: () => import('./vpgPSTMOFrameTraineeOperate.vue'),
    },
    {
      path: 'frame/frametrainer/ist',
      name: 'vrtPSTMOFrameTrainerList',
      component: () => import('./vpgPSTMOFrameTrainerList.vue'),
    },
    {
      path: 'frame/frameTrainer/operate',
      name: 'vrtPSTMOFrameTrainerOperate',
      component: () => import('./vpgPSTMOFrameTrainerOperate.vue'),
    },
    // PLATFORM
    {
      path: 'platform/platform/list',
      name: 'vrtPSTMOPlatformList',
      component: () => import('./vpgPSTMOPlatformList.vue'),
    },
    {
      path: 'platform/platform/operate',
      name: 'vrtPSTMOPlatformOperate',
      component: () => import('./vpgPSTMOPlatformOperate.vue'),
    },
    {
      path: 'platform/vehicle/list',
      name: 'vrtPSTMOVehicleList',
      component: () => import('./vpgPSTMOVehicleList.vue'),
    },
    {
      path: 'platform/vehicle/operate',
      name: 'vrtPSTMOVehicleOperate',
      component: () => import('./vpgPSTMOVehicleOperate.vue'),
    },
    {
      path: 'platform/vehiclelocation/list',
      name: 'vrtPSTMOVehicleLocationList',
      component: () => import('./vpgPSTMOVehicleLocationList.vue'),
    },
    {
      path: 'platform/vehiclelocation/operate',
      name: 'vrtPSTMOVehicleLocationOperate',
      component: () => import('./vpgPSTMOVehicleLocationOperate.vue'),
    },
    {
      path: 'platform/platformlesson/list',
      name: 'vrtPSTMOPlatformLessonList',
      component: () => import('./vpgPSTMOPlatformLessonList.vue'),
    },
    {
      path: 'platform/platformvehicle/list',
      name: 'vrtPSTMOPlatformVehicleList',
      component: () => import('./vpgPSTMOPlatformVehicleList.vue'),
    },
    {
      path: 'platform/platformvehicle/operate',
      name: 'vrtPSTMOPlatformVehicleOperate',
      component: () => import('./vpgPSTMOPlatformVehicleOperate.vue'),
    },
    // TRAINING PROGRAMME
    // {},
    // FAMILIRISATION & ASSESSMENT
    {
      path: 'fna/fnaformlist',
      name: 'vrtPSFnAFormList',
      component: () => import('./vpgPSTMOFnAFormList.vue'),
    },
    {
      path: 'fna/fnaformoperate',
      name: 'vrtPSFnAFormOperate',
      component: () => import('./vpgPSTMOFnAFormOperate.vue'),
    },
    // STATEMENT
    {
      path: 'statement/statementlist',
      name: 'vrtPSStatementList',
      component: () => import('./vpgPSTMOStatementList.vue'),
    },
    {
      path: 'statement/statementoperate',
      name: 'vrtPSStatementOperate',
      component: () => import('./vpgPSTMOStatementOperate.vue'),
    },
    {
      path: 'statement/statementcreate',
      name: 'vrtPSStatementCreate',
      component: () => import('./vpgPSTMOStatementCreate.vue'),
    },
    {
      path: 'statement/statementcreatelist',
      name: 'vrtPSStatementCreateList',
      component: () => import('./vpgPSTMOStatementCreateList.vue'),
    },
    {
      path: 'statement/oocformlist',
      name: 'vrtPSTMOOOCFormList',
      component: () => import('./vpgPSTMOOOCFormList.vue'),
    },
    {
      path: 'statement/oocform',
      name: 'vrtPSTMOOOCFormOperate',
      component: () => import('./vpgPSTMOOOCFormOperate.vue'),
    },
    // ANNUAL CURRENCY PRACTICAL ASSESSMENT
    {
      path: 'ac/acformlist',
      name: 'vrtPSACFormList',
      component: () => import('./vpgPSTMOACFormList.vue'),
    },
    {
      path: 'ac/acformoperate',
      name: 'vrtPSACFormOperate',
      component: () => import('./vpgPSTMOACFormOperate.vue'),
    },
    // TLS (Testing Licensing Section)
    {
      path: 'tls/resultlist',
      name: 'vrtPSTLSResultList',
      component: () => import('./vpgPSTMOTLSResultList.vue'),
    },
    {
      path: 'tls/resultoperate',
      name: 'vrtPSTLSResultOperate',
      component: () => import('./vpgPSTMOTLSResultOperate.vue'),
    },
    {
      path: 'tls/resultsummary',
      name: 'vrtPSTLSResultSummary',
      component: () => import('./vpgPSTMOTLSResultSummary.vue'),
    },
    // MRS
    {
      path: 'mrs/recordlist',
      name: 'vrtPSTMOMRSRecordList',
      component: () => import('./vpgPSTMOMRSRecordList.vue'),
    },
    {
      path: 'mrs/recordoperate',
      name: 'vrtPSTMOMRSRecordOperate',
      component: () => import('./vpgPSTMOMRSRecordOperate.vue'),
    },
    // REPORT
    {
      path: 'report/dailtytraineeparadestatelist',
      name: 'vrtPSTMODailyTraineeParadeStateList',
      component: () => import('./vpgPSTMODailyTraineeParadeStateList.vue'),
    },
    {
      path: 'report/dailtytraineeparadestateoperate',
      name: 'vrtPSTMODailyTraineeParadeStateOperate',
      component: () => import('./vpgPSTMODailyTraineeParadeStateOperate.vue'),
    },
    {
      path: 'report/ttsallrecordlist',
      name: 'vrtPSTMOTTSAllRecordList',
      component: () => import('./vpgPSTMOTTSAllRecordList.vue'),
    },
  ],
};

export default vrtPSTMO;
